import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormUtils } from '../../../../../shared/helpers/formUtils';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'impact',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './impact.component.html',
  styleUrl: './impact.component.css'
})
export class ImpactComponent implements OnInit, OnChanges {

  @Input() studentInterviewData: any;
  @Output() onSaveSection3 = new EventEmitter<any>();

  impactForm: FormGroup = new FormGroup([]);
  questionList = [
    {
      question: "How do you think the persons or group you threatened feels about what you said or did? *",
      formControlName: "target_feelings",
    },
    {
      question: "What was the reason you said or did that? *",
      formControlName: "reason",
    },
    {
      question: "What are you going to do now that this has happened? *",
      formControlName: "next_actions",
    },
    {
      question: "How will or did your parents respond to this situation? *",
      formControlName: "parent_response",
    },
    {
      question: "Are there others in your family who are or will be aware, and how will they respond? *",
      formControlName: "family_response",
    }
  ]

  constructor(
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['studentInterviewData'] && this.studentInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm(): void {
    this.questionList.forEach(question => {
      this.impactForm.addControl(question.formControlName, new FormControl(this.studentInterviewData?.[question.formControlName] || '', Validators.required));
    });
  }

  saveImpact(): void {
    if (this.impactForm.valid) {
      this.onSaveSection3.emit(this.impactForm.value);
    }
  }

}
